import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import request from 'src/utils/request'

const initialState = {
  isLoading: false,
  isSuccess: false,
  wilayaData: [],
  error: '',
}

export const getWilayaList = createAsyncThunk('wilaya/getWilayaList', async (_, thunkAPI) => {
  try {
    const token = await thunkAPI.getState().auth.student.token
    const res = await request(token).get(`/students/wilaya`)
    const data = await res.data
    return data
  } catch (err) {
    toast.error(err.response.data)
    return thunkAPI.rejectWithValue(err.response.data)
  }
})

export const wilayaSlice = createSlice({
  name: 'wilaya',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getWilayaList.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(getWilayaList.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          wilayaData: action.payload,
          error: '',
        }
      })
      .addCase(getWilayaList.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
  },
})

export default wilayaSlice.reducer
